<template lang="pug">
  section#tabela-os-detalhe__container
    el-row
      el-col(:span="24")#tabela-os-detalhe__colunas
        div(class="card-body")
          el-table(
            :data="dados.tecnicos"
            style="cursor: pointer"
          )
            el-table-column(
              fixed
              label='Nome do técnico',
              min-width="260",
              prop="nomeTecnico"
            )
            el-table-column(
              label='Função',
              min-width="90",
              prop="funcaoTecnico"
            )
            el-table-column(
              label='Aguardando chegar ao técnico',
              min-width="180",
              align="center",
              :formatter="aguardandoAnalisePai"
            )
            el-table-column(
              label='Aguardando análise',
              min-width="140",
              align="center",
              :formatter="aguardandoAnalise"
            )
            el-table-column(
              label='Em análise',
              min-width="80",
              align="center",
              :formatter="emAnalise"
            )
            el-table-column(
              label='Em revisão',
              min-width="80",
              align="center",
              :formatter="emRevisao"
            )
            el-table-column(
              label='Finalizado',
              min-width="90",
              align="center",
              :formatter="concluido"
            )
            el-table-column(
              label='Total',
              min-width="60",
              align="center",
              :formatter="total"
            )
    el-row#tabela-detalhe__linha-total Total geral: {{totalProcessos}}
</template>

<script>
const AGUARDANDO_ANALISE_PROCESSO_PAI = 'AGUARDANDO_ANALISE_PROCESSO_PAI'
const AGUARDANDO_ANALISE = 'AGUARDANDO_ANALISE'
const EM_ANALISE = 'EM_ANALISE'
const EM_REVISAO = 'EM_REVISAO'
const FINALIZADO = 'FINALIZADO'

export default {
  props: {
    dados: {
      required: true
    }
  },

  methods: {
    aguardandoAnalisePai (prop) {
      let total = 0

      prop.processos.forEach((item) => {
        if (item.status.codigo === AGUARDANDO_ANALISE_PROCESSO_PAI) {
          total = item.quantidade
        }
      })

      return total
    },

    aguardandoAnalise (prop) {
      let total = 0

      prop.processos.forEach((item) => {
        if (item.status.codigo === AGUARDANDO_ANALISE) {
          total = item.quantidade
        }
      })

      return total
    },

    emAnalise (prop) {
      let total = 0

      prop.processos.forEach((item) => {
        if (item.status.codigo === EM_ANALISE) {
          total = item.quantidade
        }
      })

      return total
    },

    emRevisao (prop) {
      let total = 0

      prop.processos.forEach((item) => {
        if (item.status.codigo === EM_REVISAO) {
          total = item.quantidade
        }
      })

      return total
    },

    concluido (prop) {
      let total = 0

      prop.processos.forEach((item) => {
        if (item.status.codigo === FINALIZADO) {
          total = item.quantidade
        }
      })
      return total
    },

    total (prop) {
      let total = 0

      prop.processos.forEach((item) => {
        total += item.quantidade
      })

      return total
    }
  },

  computed: {
    totalProcessos () {
      let totalProcessos = 0

      if (this.dados && this.dados.tecnicos) {
        const { tecnicos } = this.dados

        tecnicos.forEach((tecnico) => {
          tecnico.processos.forEach((processo) => {
            totalProcessos += processo.quantidade
          })
        })
      }

      return totalProcessos / 2
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/_variables.scss';
#tabela-detalhe__linha-total {
  padding: 10px 33px;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/os/TabelaDetalheOS.vue